// MockDataBanner.tsx — Dev-only banner indicating mock/placeholder data.
//
// Rendered only when import.meta.env.VITE_DFX_NETWORK !== 'ic'.
// Copy matches Lore-approved MB-01 / MB-02 from the copy table.
// Removed automatically in production builds by the env gate.

import React from 'react';

export default function MockDataBanner(): React.ReactElement | null {
  const isProduction = import.meta.env.VITE_DFX_NETWORK === 'ic';
  if (isProduction) return null;

  const now = new Date();
  const snapshot = now.toISOString().replace('T', ' · ').slice(0, 22) + ' UTC';

  return (
    <div className="mock-banner" role="status">
      <span>
        <strong>Mock data</strong>
        {' '}· Static placeholder values throughout. Pixel replaces with live canister + Cloudflare API calls.
      </span>
      <span>Snapshot · {snapshot}</span>
    </div>
  );
}
